// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","container":"styles_container__ewY7F","logo":"styles_logo__zyMPa"};